<style scoped>
    .ivu-btn{
        margin-right: 5px;
    }
</style>
<template>
    <div>
        <div class="line">
            <h3>员工名单</h3>
            <div class="line">
                <Button :type="orderButtonType(order)" size="small" @click="setCurOrder(order)" v-for="order in orders" :disabled="isCurOrder(order)" :key="order.id">
                    <span>{{order.customer.account}}</span>
                </Button>
            </div>
        </div>
        <div class="hr"></div>
        <div class="line" v-if="cur_order.customer">
            <span class="text-large text-bold">已选择员工: {{cur_order.customer.account}}</span>
            <Table
                border
                stripe
                :columns="order_columns"
                :data="select_data"
                size="small">
            </Table>
        </div>

        <div class="line" v-if="cur_order.options">
            <h2>
                <span>期权信息</span>
            </h2>
            <div class="line">
                <table class="mis-table text-center">
                    <tr>
                        <th>期权起始日期</th>
                        <th>期权数量</th>
                        <th>摊薄比例</th>
                        <th>摊薄/回购后数量</th>
                        <th>成熟比例</th>
                        <th>成熟数量</th>
                        <th>
                            <Tooltip transfer placement="top">
                                <span>行权价格</span>
                                <Icon type="ios-help"></Icon>
                                <span slot="content">
                                        买入价
                                    </span>
                            </Tooltip>
                        </th>
                        <th>
                            <Tooltip transfer placement="top">
                                <span>公司估值</span>
                                <Icon type="ios-help"></Icon>
                                <span slot="content">
                                        卖出价
                                    </span>
                            </Tooltip>
                        </th>
                        <th>期权总价值</th>
                        <th>已成熟总价值</th>
                    </tr>
                    <tr v-for="option in cur_order.options" :key="option.id">
                        <td>{{option.start_date}}</td>
                        <td>{{option.option_count}}</td>
                        <td>
                            <i-circle :size="32" :percent="option.dilute_scale * 100">
                                <span class="circle-text">{{option.dilute_scale * 100}}%</span>
                            </i-circle>
                        </td>
                        <td>{{option.dilute_count}}</td>
                        <td>
                            <i-circle :size="32" :percent="option.ripe_scale * 100">
                                <span class="circle-text">{{option.ripe_scale * 100}}%</span>
                            </i-circle>
                        </td>
                        <td>{{option.ripe_count}}</td>
                        <td>￥{{option.buying_price}}</td>
                        <td>￥{{option.selling_price}}</td>
                        <td>￥{{option.option_total_price}}</td>
                        <td>￥{{option.ripe_total_price}}</td>
                    </tr>
                </table>
            </div>
            <div class="hr"></div>
            <div class="line">
                <div>
                    <h2>模拟卖出</h2>
                </div>
                <div class="line">
                    <table class="mis-table text-center">
                        <tr>
                            <th width="140">*拟卖出股数</th>
                            <th width="140">*拟卖出期权总价值</th>
                            <th width="140">*拟卖出期权后实得</th>
                            <th>期权产生个税</th>
                            <th>备注</th>
                            <th>计税基础</th>
                            <th>个税</th>
                            <th>年终奖</th>
                            <th>年终奖个税</th>
                        </tr>
                        <tr>
                            <td>
                                <i-input class="order-input" size="small" number @on-change="calcOptionOrder('selling_count')" v-model="option_order.selling_count"></i-input>
                            </td>
                            <td>
                                <i-input class="order-input" size="small" number @on-change="calcOptionOrder('total_price')" v-model="option_order.total_price"></i-input>
                            </td>
                            <td>
                                <i-input class="order-input" size="small" number @on-change="calcOptionOrder('net_price')" v-model="option_order.net_price"></i-input>
                            </td>
                            <td>￥{{option_order.option_tax}}</td>
                            <td>
                                <span v-html="option_order.desc"></span>
                            </td>
                            <td>￥{{option_order.tax_base}}</td>
                            <td>￥{{option_order.total_tax}}</td>
                            <td>￥{{option_order.annual_bonus}}</td>
                            <td>￥{{option_order.bonus_tax}}</td>
                        </tr>
                    </table>
                    <div class="line">
                        <span>个税盲区(拟卖出股权的总价值)</span>
                        <span class="color-error text-bold" v-if="order_alert">已落入个税盲区, 建议修改</span>
                        <table class="mis-table text-center blind-area-table">
                            <tr>
                                <th width="150">上限</th>
                                <th width="150">下限</th>
                            </tr>
                            <tr :class="{'color-error': blind_area.alert}" v-for="(blind_area, index) in blind_areas" :key="index">
                                <td>{{blind_area.start}}</td>
                                <td>{{blind_area.end}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Util from '../../../libs/util';
    import FinUtil from '../../../libs/fin_util';
    export default {
        data () {
            return {
                orders: [],
                cur_order: {},
                order_columns: [
                    {
                        title: '订单年份',
                        align: 'center',
                        key: 'year'
                    },
                    {
                        title: '卖出数量',
                        align: 'center',
                        key: 'selling_count'
                    },
                    {
                        title: '卖出总价值',
                        align: 'center',
                        key: 'total_price',
                        render: (h, params) => {
                            return `￥${Util.formatPrice(params.row.total_price)}`
                        }
                    },
                    {
                        title: '卖出后实得',
                        align: 'center',
                        key: 'net_price',
                        render: (h, params) => {
                            return `￥${Util.formatPrice(params.row.net_price)}`
                        }
                    },
                    {
                        title: '期权个税',
                        align: 'center',
                        key: 'option_tax',
                        render: (h, params) => {
                            return `￥${Util.formatPrice(params.row.option_tax)}`
                        }
                    },
                    {
                        title: '计税基础',
                        align: 'center',
                        key: 'tax_base',
                        render: (h, params) => {
                            return `￥${Util.formatPrice(params.row.tax_base)}`
                        }
                    },
                    {
                        title: '个税总计',
                        align: 'center',
                        key: 'total_tax',
                        render: (h, params) => {
                            return `￥${Util.formatPrice(params.row.total_tax)}`
                        }
                    },
                    {
                        title: '年终奖',
                        align: 'center',
                        key: 'annual_bonus',
                        render: (h, params) => {
                            return `￥${Util.formatPrice(params.row.annual_bonus)}`
                        }
                    },
                    {
                        title: '年终奖个税',
                        align: 'center',
                        key: 'bonus_tax',
                        render: (h, params) => {
                            return `￥${Util.formatPrice(params.row.bonus_tax)}`
                        }
                    },
                    {
                        title: '订单明细',
                        align: 'center',
                        width: 100,
                        key: 'desc',
                        render: (h, params) => {
                            return h('div', {
                                domProps: {
                                    innerHTML: params.row.desc || ''
                                }
                            })
                        }
                    }
                ],
                option_order: {
                    customer_id: 0,
                    year: '',
                    buying_price: 0,
                    selling_count: 0,
                    selling_price: 0,
                    total_price: 0,
                    // extra calc
                    net_price: 0,
                    option_tax: 0,
                    tax_base: 0,
                    total_tax: 0,
                    annual_bonus: 0,
                    bonus_tax: 0,
                    desc: ''
                },
                order_alert: false,
                blind_areas: [],
                calc_option_timer: 0,
                options: []
            }
        },
        computed: {
            select_data(){
                return this.cur_order.order ? [this.cur_order.order] : [];
            }
        },
        created(){
            this.init();
        },
        mounted(){
            //
        },
        methods: {
            init(){
                this.getOrderCustomers();
            },
            getOrderCustomers(){
                Util.ajax.get(Util.api.option_order_customers, {
                    params: {}
                }).then((response)=>{
                    return response.data;
                }).then((data)=>{
                    console.log(data);
                    this.orders = [];
                    data.orders.forEach((order)=>{
                        this.orders.push(order);
                    });
                }).catch((e)=>{
                    console.log(e);
                    this.$Modal.error({title: '提示', content: e.message});
                });
            },
            setCurOrder(order){
                this.cur_order = order;
                this.options = [];
                this.cur_order.options.forEach((option)=>{
                    //预处理(卖出数量 < 25% and < ripe_count)
                    option.calc_price = math.eval(`${option.selling_price} - ${option.buying_price}`).toFixed(2);
                    let max_sell_count = option.dilute_count * 0.25;
                    option.max_sell_count = math.eval(`${option.ripe_count} < ${max_sell_count}`) ? option.ripe_count : max_sell_count;
                    option.max_sell_price = math.eval(`${option.max_sell_count} * ${option.calc_price}`).toFixed(2);
                    this.options.push(option);
                });
                this.option_order.annual_bonus = this.cur_order.annual_bonus;
                this.genBlindAreas();
                this.getSubmittedOptionOrders();
                this.calcOptionOrder('selling_count');
            },
            isCurOrder(order){
                if(this.cur_order.customer){
                    return order.customer.id === this.cur_order.customer.id;
                }else{
                    return false;
                }
            },
            orderButtonType(order){
                return this.isCurOrder(order) ? 'primary' : 'dashed';
            },
            calcOptionOrder(change_key){
                let max_sell_count = 0;
                let max_sell_price = 0;
                this.options.forEach((option)=>{
                    max_sell_count = math.eval(`${max_sell_count} + ${option.max_sell_count}`).toFixed(2);
                    max_sell_price = math.eval(`${max_sell_price} + ${option.max_sell_price}`).toFixed(2);
                });
                clearTimeout(this.calc_option_timer);
                try{
                    this.option_order.bonus_tax = FinUtil.calcBonusTax20180222(this.option_order.annual_bonus);
                    switch (change_key){
                        case 'selling_count':
                            if(math.eval(`${this.option_order.selling_count} > ${max_sell_count}`)){
                                this.option_order.selling_count = max_sell_count;
                                console.log('exceed...');
                                this.$Message.warning(`最大卖出数量不能超过: ${max_sell_count}`);
                            }
                            this.option_order.total_price = this.getTotalPriceBySellingCount(this.option_order.selling_count);
                            this.option_order.tax_base = math.eval(`${this.option_order.total_price} + ${this.option_order.annual_bonus}`).toFixed(2);
                            this.option_order.total_tax = FinUtil.calcBonusTax20180222(this.option_order.tax_base);
                            this.option_order.option_tax = math.eval(`${this.option_order.total_tax} - ${this.option_order.bonus_tax}`).toFixed(2);
                            this.option_order.net_price = math.eval(`${this.option_order.total_price} - ${this.option_order.option_tax}`).toFixed(2);
                            break;
                        case 'total_price':
                            if(math.eval(`${this.option_order.total_price} > ${max_sell_price}`)){
                                this.option_order.total_price = max_sell_price;
                                this.$Message.warning(`卖出总价值不能超过: ${max_sell_price}`);
                            }
                            this.option_order.selling_count = this.getSellingCountByTotalPrice(this.option_order.total_price);
                            this.calc_option_timer = setTimeout(()=>{
                                this.calcOptionOrder('selling_count');
                            }, 800);
                            //this.option_order.tax_base = math.eval(`${this.option_order.total_price} + ${this.option_order.annual_bonus}`).toFixed(2);
                            //this.option_order.total_tax = FinUtil.calcBonusTax20180222(this.option_order.tax_base);
                            //this.option_order.option_tax = math.eval(`${this.option_order.total_tax} - ${this.option_order.bonus_tax}`).toFixed(2);
                            //this.option_order.net_price = math.eval(`${this.option_order.total_price} - ${this.option_order.option_tax}`).toFixed(2);
                            break;
                        case 'net_price':
                            this.option_order.tax_base = FinUtil.calcTaxBaseByNetOptionPrice20180222(this.option_order.net_price, this.option_order.annual_bonus, this.option_order.bonus_tax);
                            this.option_order.total_tax = FinUtil.calcBonusTax20180222(this.option_order.tax_base);
                            this.option_order.option_tax = math.eval(`${this.option_order.total_tax} - ${this.option_order.bonus_tax}`).toFixed(2);
                            this.option_order.total_price = math.eval(`${this.option_order.net_price} + ${this.option_order.option_tax}`).toFixed(2);
                            this.calc_option_timer = setTimeout(()=>{
                                this.calcOptionOrder('total_price');
                            }, 800);
                            //this.option_order.selling_count = math.eval(`${this.option_order.total_price || 0} / ${calc_price}`).toFixed(2);
                            break;
                        default:
                            console.error('error input type');
                            break;
                    }
                    this.order_alert = FinUtil.lookup(this.option_order.tax_base, [18000.0,19283.33,54000.0,60187.5,108000.0,114600,420000.0,447500,660000.0,706538.46,960000.0,1120000], [false,true,false,true,false,true,false,true,false,true,false,true,false])
                    this.blind_areas.forEach((area)=>{
                        let total_price = this.option_order.total_price;
                        area.alert = math.eval(`${total_price} >= ${area.start}`) && math.eval(`${total_price} < ${area.end}`);
                    });
                }catch (e){
                    console.log(e.message);
                    //this.$Message.error(e.message);
                }
            },
            genBlindAreas(){
                let calc_base = [
                    [18000.00, 19283.33],
                    [54000.00, 60187.50],
                    [108000.00, 114600.00],
                    [420000.00, 447500.00],
                    [660000.00, 706538.46],
                    [960000.00, 1120000.00]
                ];
                this.blind_areas = [];
                let bonus = this.option_order.annual_bonus;
                calc_base.forEach((base)=>{
                    let start = math.eval(`${base[0]} - ${bonus}`).toFixed(2);
                    let end = math.eval(`${base[1]} - ${bonus}`).toFixed(2);
                    this.blind_areas.push({start: start, end: end, alert: false});
                });
            },
            getSubmittedOptionOrders(){
                Util.ajax.get(Util.api.my_option_order).then((response)=>{
                    return response.data;
                }).then((data)=>{
                    console.log(data);
                    if(data.code === 1){
                        this.submitted_orders = [];
                        data.orders.forEach((order)=>{
                            this.submitted_orders.push(order);
                        });
                    }else{
                        this.$Modal.error({title: '提示', content: data.msg});
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.$Modal.error({title: '提示', content: e.message});
                });
            },
            getTotalPriceBySellingCount(count){
                let left_count = math.eval(`${count} * 1`).toFixed(2);
                let price = 0;
                this.option_order.desc = '';
                this.options.forEach((option)=>{
                    if(math.eval(`${left_count} > 0`)){
                        if(math.eval(`${option.max_sell_count} >= ${left_count}`)){
                            price = math.eval(`${price} + ${left_count} * ${option.calc_price}`).toFixed(2);
                            this.option_order.desc += `<p>${option.start_date}授予期权卖出 ${left_count} 股</p>`;
                        }else{
                            price = math.eval(`${price} + ${option.max_sell_price}`).toFixed(2);
                            this.option_order.desc += `<p>${option.start_date}授予期权卖出 ${option.max_sell_count} 股</p>`;
                        }
                        left_count = math.eval(`${left_count} - ${option.max_sell_count}`).toFixed(2);
                    }
                });
                return price;
            },
            getSellingCountByTotalPrice(price){
                let left_price = math.eval(`${price} * 1`).toFixed(2);
                let count = 0;
                this.option_order.desc = '';
                this.options.forEach((option)=>{
                    if(math.eval(`${left_price} > 0`)){
                        if(math.eval(`${option.max_sell_price} >= ${left_price}`)){
                            let option_sell_count = math.eval(`${left_price} / ${option.calc_price}`).toFixed(2);
                            count = math.eval(`${count} + ${option_sell_count}`).toFixed(2);
                            this.option_order.desc += `<p>${option.start_date}授予期权卖出 ${option_sell_count} 股</p>`;
                        }else{
                            count = math.eval(`${count} + ${option.max_sell_count}`).toFixed(2);
                            this.option_order.desc += `<p>${option.start_date}授予期权卖出 ${option.max_sell_count} 股</p>`;
                        }
                        left_price = math.eval(`${left_price} - ${option.max_sell_price}`).toFixed(2);
                    }
                });
                return count;
            },
        }
    }
</script>
